module.exports = __webpack_public_path__ + "img/notification.949eb4bb.svg";